import request from '@/request/request'

// 查询应用服务器日志列表
export function listAppServerLog(query) {
    return request({
        url: '/api/system-server/appServerLog/list',
        method: 'get',
        params: query
    })
}

// 查询应用服务器日志详细信息
export function getAppServerLog(id) {
    return request({
        url: '/api/system-server/appServerLog/' + id,
        method: 'get'
    })
}

// 新增应用服务器日志
export function addAppServerLog(data) {
    return request({
        url: '/api/system-server/appServerLog',
        method: 'post',
        data: data
    })
}

// 修改应用服务器日志
export function updateAppServerLog(data) {
    return request({
        url: '/api/system-server/appServerLog/edit',
        method: 'post',
        data: data
    })
}

// 删除应用服务器日志
export function delAppServerLog(ids) {
    return request({
        url: '/api/system-server/appServerLog/delete/' + ids,
        method: 'post'
    })
}
